import React from 'react';

const BeautySalonsPage = () => {
  return (
    <div>
      <h1>Beauty Salons</h1>
    </div>
  );
};

export default BeautySalonsPage;
